import { initSwiper } from '../../components/swiper';

const SELECTOR = '[data-product-page-recommendations]';
const SELECTOR_RECOMMENDATIONS_CONTENT = '[data-product-recommendations-content]';

const getRecommendationsMarkup = doc => {
  const nested = doc.querySelector(SELECTOR)?.querySelector(SELECTOR_RECOMMENDATIONS_CONTENT);
  if (nested?.outerHTML) return nested.outerHTML;
  return doc.querySelector(SELECTOR_RECOMMENDATIONS_CONTENT)?.outerHTML;
};

const loadRecommendations = async el => {
  if (!el.dataset.url || el.dataset.recommendationsLoaded === 'true') return;

  try {
    const response = await fetch(el.dataset.url);
    if (response.ok) {
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const markup = getRecommendationsMarkup(doc);
      if (markup) el.innerHTML = markup;
    }
  } catch (err) {
    console.error('Error fetching related products:', err);
  } finally {
    el.classList.remove('hidden');
    const sliderEl = el.querySelector('[data-swiper]');
    if (sliderEl) initSwiper(sliderEl);
    el.dataset.recommendationsLoaded = 'true';
  }
};

const initRelatedProducts = () => {
  document.querySelectorAll(`${SELECTOR}:not([data-recommendations-loaded])`).forEach(loadRecommendations);
};

export default initRelatedProducts;
